var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "flex flex-center" }, [
    _vm.message
      ? _c(
          "div",
          { staticClass: "q-ma-lg" },
          [
            _c(
              "q-alert",
              {
                attrs: {
                  color: "blue-4",
                  icon: "info",
                  enter: "fadeIn",
                  leave: "fadeOut",
                  appear: "",
                  dismissible: ""
                }
              },
              [
                _c("b", [_vm._v("Logged out:")]),
                _vm._v("\n      " + _vm._s(_vm.message) + "\n    ")
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitLogin.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "q-card",
          {
            staticClass: "md-card q-mt-lg relative-position",
            attrs: { color: "grey-1" }
          },
          [
            _c(
              "q-card-main",
              [
                _c(
                  "q-field",
                  {
                    staticClass: "q-mt-lg q-mb-lg text-black",
                    attrs: {
                      label: "Email",
                      orientation: "vertical",
                      icon: "account_box"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { type: "email", autofocus: "" },
                      model: {
                        value: _vm.form.userName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "userName", $$v)
                        },
                        expression: "form.userName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  {
                    staticClass: "q-mt-lg q-mb-lg text-black",
                    attrs: {
                      icon: "lock",
                      orientation: "vertical",
                      label: "Password"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { type: "password", label: "Password" },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    })
                  ],
                  1
                ),
                _vm.error
                  ? _c(
                      "div",
                      { staticClass: "q-mt-lg q-mb-lg" },
                      [
                        _c(
                          "q-alert",
                          {
                            attrs: {
                              color: "negative",
                              icon: "error",
                              enter: "fadeIn",
                              leave: "fadeOut",
                              appear: "",
                              dismissible: ""
                            }
                          },
                          [
                            _c("b", [_vm._v("Login Failed:")]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.error) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        label: "Forgot Password?",
                        color: "primary",
                        size: "sm",
                        flat: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/auth/forgot")
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "q-card-actions",
              [
                _c(
                  "q-btn",
                  {
                    staticClass: "full-width no-shadow",
                    attrs: {
                      loader: "",
                      large: "",
                      color: "primary",
                      disabled: _vm.loading,
                      type: "submit",
                      label: "Login"
                    },
                    model: {
                      value: _vm.loading,
                      callback: function($$v) {
                        _vm.loading = $$v
                      },
                      expression: "loading"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "loading" }, slot: "loading" },
                      [
                        _c("q-spinner", { staticClass: "on-left" }),
                        _vm._v("Logging in...\n          ")
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c("q-inner-loading", { attrs: { visible: _vm.loading } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }